/**
 * Created by SH: 02/20/2020
 */

import {IReelSymbolStates, WGSpriteSymbol} from "./Symbol/WGSpriteSymbol";
import {WGEnginePlayer} from "./WGEnginePlayer";
import {WGParsedInitData} from "../server/data/WGParsedInitData";
import {WGParsedGameData} from "../server/data/WGParsedGameData";
import {IReelConfig} from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineView";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {ReelSymbolStates} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Timeline, TimelineMax} from "gsap";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {WGGameConfig} from "../WGGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IReelSpriteSymbol} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/IReelSpriteSymbol";
import {ReelEngineController, ReelState} from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {WildNudgePresentation} from "../presentations/features/nudge/WildNudgePresentation";
import {NoWinEvent} from "../presentations/WGNoWinPresentation";
import {WGSymbolData} from "./Symbol/WGSymbolData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SymbolData} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";

export class WGEngineController extends ReelEngineController {
    // scatterOverlayItems.
    public _scatterSymbolContainer: PIXI.Container;
    private _symWinState: boolean[][] = [];
    private _stackofWildPresentonReel: boolean = false;
    private _lastWildsymboladded: boolean = true;
    private _stackSymbolPiece: string[] = [];
    private _spinAlreadyDelayed: boolean = false;
    private _stickyWildReels: boolean[] = [];
    private _isSuperFreeSpin: boolean = false;
    public createScatterForAnticipation: boolean = false;
    private _reelSetPointer: number = 0;
    private gpGraph: PIXI.Graphics;
    private tlAnim: TimelineMax;

    constructor(config: IReelConfig) {
        super(config);

        this._scatterSymbolContainer = new PIXI.Container();
        StageManager.getLayer(WGGameConfig.instance.LAYERS.SYMBOL_OVERLAY.name).addChild(this._scatterSymbolContainer);
        this.createMasForScatterSymbolCOntainer();
        EventHandler.addEventListener(this, NoWinEvent.DIM_DOWN_OVERLAYS, (event: GameEvent) => this.dimOverlays(event.params[0]));
    }

    public changeAlpha(alpha: number, duration: number): TimelineMax {
        this.tlAnim = Helper.timeLineKiller(this.tlAnim, new TimelineMax());
        this.tlAnim.to(this.gpGraph, duration, {alpha: alpha});
        return this.tlAnim;
    }

    protected addChildObjOrder(): void {
        super.addChildObjOrder();
        this.gpGraph = this.createGraphic();
        this.gpGraph.name = "";
        this.gpGraph.alpha = 0;
    }

    /**
     * override this function to customize masking width.
     */
    protected createGraphic(): PIXI.Graphics {
        const graphicBg: PIXI.Graphics = new PIXI.Graphics();
        graphicBg.beginFill(0x000000, 1);
        graphicBg.drawRect((-SymbolData.DEFAULT_SYMBOL.DIM.WIDTH * 0.5) - 15, -SymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5,
            SymbolData.DEFAULT_SYMBOL.DIM.WIDTH + 30, this.reelDim.HEIGHT);
        graphicBg.endFill();
        graphicBg.name = "normalReelMask";
        this.addChild(graphicBg);
        return graphicBg;
    }

    /**
     * function to dim wild text and mulitplier on it
     * if there is no win for that particular piece
     */
    private dimOverlays(force: boolean = true): void {
        if (!((this._symWinState[this.reelID]).filter(value => value).length) || force) {
            if (this.reelID > 0 && this.reelID < 5 && !this._stickyWildReels[this.reelID]) {
                for (let i = 0; i < WildNudgePresentation._wildMultiplierContainer[this.reelID - 1]!.children.length; i++) {
                    (WildNudgePresentation._wildMultiplierContainer[this.reelID - 1].children[i] as PIXI.Sprite).tint = 0x555555;
                }
            }
        }
        let symbols = [...this._scatterSymbolContainer.children];
        for (let i: number = 0; i < symbols.length; i++) {
            if ((!(this._symWinState[this.reelID][(symbols[i] as WGSpriteSymbol).posID])) && this._nextReelSetName !== "FREESPIN_REELSET") {
                (symbols[i] as WGSpriteSymbol).changeState({state: IReelSymbolStates.NOWIN});
            }
        }
    }

    /**
     * undiming all wild text and mulitplier before spin start
     */
    private undimBeforeSpin(): void {
        this.undimWildsOverlay();
        let symbols = [...this._scatterSymbolContainer.children];
        for (let i: number = 0; i < symbols.length; i++) {
            (symbols[i] as WGSpriteSymbol).changeState({state: IReelSymbolStates.NORMAL});
        }
    }

    public undimWildsOverlay(): void {
        if (this.reelID > 0 && this.reelID < 5) {
            for (let i = 0; i < WildNudgePresentation._wildMultiplierContainer[this.reelID - 1]!.children.length; i++) {
                (WildNudgePresentation._wildMultiplierContainer[this.reelID - 1].children[i] as PIXI.Sprite).tint = 16777215;
            }
        }
    }

    /**
     * function to create mask for scatterSybmol container
     * that contains overlay. so that while spinning it won't show above reel background
     */
    private createMasForScatterSymbolCOntainer(): void {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0xFF3300);
        graphics.drawRect(-20, 90, 780, 594);
        graphics.endFill();
        StageManager.getLayer(WGGameConfig.instance.LAYERS.SYMBOLS.name).addChild(graphics);
        this._scatterSymbolContainer.mask = graphics;
    }

    public createNextAnimation(state: string, updateState: boolean = false): Timeline {
        if (this.state.equal(state)) return this.Engine.nextTimeline ? this.Engine.nextTimeline : this.Engine.activeTimeline;
        switch (state) {
            case ReelState.START:
                this.Engine.Start();
                break;
            case ReelState.STEP:
                this.Engine.Step();
                break;
            case ReelState.STOP:
            case ReelState.FAST_STOP:
            case ReelState.QUICK_STOP:
                this.Engine.Stop(this.isFast);
                break;
            case ReelState.NUDGE:
                this.Engine.gameNudge(this.reelID);
                this.hidescatteronNudgeing();
                break;
            case ReelState.IDLE:
            case ReelState.INACTIVE:
                this.Engine.Idle();
                break;
            default:
                console.error("Seems like you are using an undefined ReelState.");
                break;
        }
        while (!this.Engine.nextTimeline) this.createNextAnimation(state, updateState);

        if (updateState) this.state.set(state);

        return this.Engine.nextTimeline;
    }

    public get scatterSymbols(): WGSpriteSymbol[] {
        return this._scatterSymbolContainer.children as WGSpriteSymbol[];
    }

    public get AllStickySymbols(): WGSpriteSymbol[] {
        return this._stickyContainer.children as WGSpriteSymbol[];
    }

    public get AllWindowSymbols(): WGSpriteSymbol[] {
        return this.AllSymbols.filter(sym => {
            return (sym.posID >= 0 && sym.posID < this.windowAmount); // need to look into it. why -1?
        });
    }

    public get AllSymbols(): WGSpriteSymbol[] {
        return this._areaContainer.children as WGSpriteSymbol[];
    }

    public get Engine(): WGEnginePlayer {
        return <WGEnginePlayer>this._engine;
    }

    public getSymbol(symbolID: number): WGSpriteSymbol | undefined {
        return super.getSymbol(symbolID) as WGSpriteSymbol;
    }

    protected createNewSymbol(id: number, sym: string, state?: string, type?: number): WGSpriteSymbol {
        return new WGSpriteSymbol(id, sym, state, type);
    }

    protected createReelEngine(): void {
        this._engine = new WGEnginePlayer(this.engineCallbacks(), this.config.engine_config, this._areaContainer);
    }

    public getStartDelay(): number {
        if (this.isQuickStop) return this.engineConfig.DELAY.QUICK_START;
        else if (GameSetting.isFastSpin) return this.engineConfig.DELAY.FAST_START;
        return this.engineConfig.DELAY.START;
    }

    public getStopDelay(): number {
        if (this.isQuickStop) return this.engineConfig.DELAY.QUICK_STOP;
        else if (GameSetting.isFastSpin) return this.engineConfig.DELAY.FAST_STOP;
        return this.engineConfig.DELAY.STOP;
    }

    public getStartDuration(): number {
        if (this.isQuickStop) return this.engineConfig.DURATION.QUICK_START;
        else if (GameSetting.isFastSpin) return this.engineConfig.DURATION.FAST_START;
        return this.engineConfig.DURATION.START;
    }

    public getStopDuration(): number {
        if (this.isQuickStop) return this.engineConfig.DURATION.QUICK_STOP;
        else if (GameSetting.isFastSpin) return this.engineConfig.DURATION.FAST_STOP;
        return this.engineConfig.DURATION.STOP;
    }

    public dataParsed(data: WGParsedInitData | WGParsedGameData): void {
        this._stackofWildPresentonReel = false;
        this.checkforWildOnReels(data.actualReels);
        this._lastWildsymboladded = false;
        this._symWinState = (data as WGParsedGameData).symbolWinStates;
        this._stickyWildReels = data.lockedWildReelsAfter;
        this._isSuperFreeSpin = data.superFreespin;
        super.dataParsed(data);
    }

    /**
     * function to  check wild on reels to position all reelsymbols accordingly
     * @param reels
     */
    private checkforWildOnReels(reels: String[][]): void {
        let noOfWIldPresent: boolean = reels[this.reelID].filter((value => value.indexOf("W") > -1)).length > 0;
        if (noOfWIldPresent) this._stackofWildPresentonReel = true;
    }

    public activateStop(): void {
        this.state.set(this.state.subState);
        this.state.set(ReelState.IDLE, true);
        this.Engine.Steps -= (this.totalOverflow - this.engineConfig.RESULT_OVERFLOW) - 1;
        this.Engine.activateNextAnimation();
    };

    protected setVisibleForOverflowSymbols(value: boolean): void {
        if (!this.isActive) return;
        // added -(this.overflowDirection - 1) to fix #56

        for (let posID: number = -(this.overflowDirection - 1); posID < this._showAmount + this.overflowTail - 1; posID++) {
            if (posID == 0) posID = this._showAmount;
            if (this.getSymbol(posID) !== undefined && (posID < 0 || posID >= this._showAmount - 1)) {
                let sym: WGSpriteSymbol = this.getSymbol(posID)!
                if (sym.stateType.state === 2 && sym.isWild) { // to fix #107 but to show wild piece.
                    sym.visible = true;
                } else {
                    sym.visible = value;
                }
            }
        }
    }

    /**
     * override this function to move scatter on top when animation
     * spin stops
     */
    protected onStopAnimationCompleted(): void {
        this._spinAlreadyDelayed = false;
        super.onStopAnimationCompleted();
        this.setVisibleForOverflowSymbols(false);
        this.updateScatterPos();
    }

    protected onBounceStarted(): void {
        this.moveScatterToTop();
        super.onBounceStarted();
        this.setWildPositions();
    }

    /**
     * function to update scatter pos
     */
    private updateScatterPos(): void {
        for (let i: number = 0; i < this.scatterSymbols.length; i++) {
            let scatterSym: WGSpriteSymbol = this.scatterSymbols[i] as WGSpriteSymbol;
            scatterSym.position = Helper.copyLocalPosition(scatterSym, this.getSymbol(scatterSym.posID)!);
        }
    }

    /**
     * function to move scatter on top
     */
    private moveScatterToTop(): void {
        for (let i: number = 0; i < this.AllWindowSymbols.length; i++) {
            let reelSymbol: WGSpriteSymbol = this.getSymbol(i + this.stepPosOffset)!;
            if (reelSymbol.isScatter) {
                reelSymbol.visible = false;
                let symbol: WGSpriteSymbol = this.createNewSymbol(i, "S");
                this._scatterSymbolContainer.addChild(symbol);
                symbol.changeState({state: IReelSymbolStates.LANDING})?.eventCallback("onUpdate", () => {
                    symbol.position = Helper.copyLocalPosition(symbol, reelSymbol);
                });
            }
        }
    }

    private hidescatteronNudgeing(): void {
        let symbols = [...this.scatterSymbols];
        for (let i: number = 0; i < symbols.length; i++) {
            symbols[i].visible = false;
        }
    }

    /**
     * function to spinOverlay scatter when spin start
     * and remove it
     */
    public spinOverlayScatterAndRemoveIt(): void {
        this.undimBeforeSpin();
        for (let i: number = 0; i < this.scatterSymbols.length; i++) {
            let sym: WGSpriteSymbol = this.getSymbol(this.scatterSymbols[i].posID)!;
            this.scatterSymbols[i].changeState({
                state: ReelSymbolStates.SPIN,
                duration: this.getStartDuration(),
                ease: this.getStartEase()
            })!.eventCallback("onUpdate", () => {
                this.scatterSymbols[i].position =
                    Helper.copyLocalPosition(this.scatterSymbols[i], sym!);
            }).eventCallback("onComplete", () => {
                this.scatterSymbols[i].remove();
                if (i == this.scatterSymbols.length - 1) {
                    this._scatterSymbolContainer.removeChildren();
                }
            });
        }
    }

    /**
     * override this function to position wild at init
     * also to call moveScatterToTop
     */
    public initReel(): void {
        this.initEngine();
        this.setCurrentReelSet(this._nextReelSetName);
        this._symbolAmount = this._showAmount = this.engineConfig.WINDOW_AMOUNT;
        let symbol: IReelSpriteSymbol;
        let symInitPos: number = this._stopReelSet.length - 1 // remove this to show coorect init reel - this.engineConfig.OVERFLOW_BOTT;
        let possAdded: number = 0;
        for (let i: number = -this.overflowDirection; i < this.windowAmount + this.overflowTail; i++) {
            let symType: string = this._stopReelSet[symInitPos % this._stopReelSet.length];
            if (symType == ReelSymbolName.EMPTY || i < 0) {
                symType = ArrayHelper.getRandomElementFromArray(["L1", "L2", "L3", "L4", "L5", "S"]);
            }

            if (symType.length > 2) {
                let index: number = Number(symType.split("*")[1]),
                    symName: string = symType.split("*")[0];
                symbol = this.createNewSymbol(i, symName, "normal", index + 1);
            } else {
                symbol = this.createNewSymbol(i, symType, "normal");
            }

            if (i == -this.overflowDirection) {
                possAdded = (symbol.symbolHeight * i) - Math.abs(i) * this.engineConfig.STEP_DISTANCE_PADDING_Y;
            } else {
                possAdded += Math.abs(symbol.symbolHeight) + this.engineConfig.STEP_DISTANCE_PADDING_Y;
            }

            symbol.position = new PIXI.Point(0, possAdded);
            this.addSymbol(symbol);
            symInitPos++;
        }
        this.setVisibleForOverflowSymbols(false);
        this._hasInit = true;

        this.state.set(ReelState.IDLE);
        this.moveScatterToTop();
        this.setWildPositions();
    }

    /**
     * override this function to made changes on wild symbol pieces
     * @param reverse
     */
    protected tryAddNextSymbol(reverse: boolean): boolean {
        let symbol: IReelSpriteSymbol;
        let symbolToCheck: IReelSpriteSymbol = reverse ? this.bottomSymbol : this.topSymbol;
        let willSpawn: boolean = this.checkSymbolBoundries(symbolToCheck, true, reverse);
        let posY: number = symbolToCheck.position.y + ((reverse ? 1 : -1) * (symbolToCheck.symbolHeight));
        // Check if it is visible by Restriction and symbol size.
        if (willSpawn) {
            let nextSymName: string = this.findNextSymbol();
            let posID: number = symbolToCheck.posID + (reverse ? 1 : -1);
            let symState: string = ReelSymbolStates.NORMAL;
            if (this.state.isSpinning || this.state.isStarting || this.state.isStopping) {
                symState = ReelSymbolStates.SPIN;
            }
            if (nextSymName === "S" && this.reelID === 6 && (this.createScatterForAnticipation || this._isSuperFreeSpin)) {
                symState = ReelSymbolStates.NORMAL;

            }
            // to check if symbol is stack or not
            if (nextSymName.length > 2) {
                let index: number = Number(nextSymName.split("*")[1]);
                symbol = this.createNewSymbol(posID, nextSymName.split("*")[0], symState, index + 1);
            } else {
                symbol = this.createNewSymbol(posID, nextSymName, symState);
            }
            // AddOffset if the symbols have a missmatch on sizes between them.
            // added this check to change wild position when added on reel
            if (nextSymName && nextSymName.indexOf("W") > -1 && this.state.isSpinning) {
                switch (nextSymName!.split("*")[1]) {
                    case "0":
                        symbol.position.y = posY - 15;
                        break;
                    case "1":
                        symbol.position.y = posY;
                        break
                    case "2":
                        symbol.position.y = posY + 15;
                        break;
                }
            } else {
                // add this line of code to set position of other symbols and remove offsets if their is wild.
                // added  this._engine.reverse  to handle other symbols y-postion when reel nudge is reverse
                let y: number = this._engine.reverse ? 0 : (posY - this.engineConfig.STEP_DISTANCE_PADDING_Y) % 198;
                symbol.position.y = posY - y;
            }
            this.addSymbol(symbol);
            this._nextSymbol = undefined;
            if (this.state.isStopping && this.Engine.Steps >= 0) {
                this.Engine.reverse ? this.Engine.Steps++ : this.Engine.Steps--;
            }
        }
        return willSpawn;
    }

    /**
     * override this function playtween on scatter overlay
     */
    protected onStarting(): void {
        super.onStarting();
        this.spinOverlayScatterAndRemoveIt();
    }

    /**
     * override this function to reposition all symbols and wild
     */
    protected onStep(): void {
        this.AllSymbols.forEach((sym, posId) => {
            this.Engine.reverse ? sym.posID-- : sym.posID++;
            sym.y += this.Engine.stepDistance;
            if (this._stackofWildPresentonReel) {
                let additionalPos: number = this._lastWildsymboladded ? 13 : 0;
                sym.y = Math.round(sym.y + additionalPos);
            } else {
                sym.y = Math.round(sym.y);
            }
        });
        let checkReverse: boolean = this.Engine.reverse;
        while (this.tryRemoveSymbol(checkReverse)) ;
        while (this.tryAddNextSymbol(checkReverse)) ;

        if ((this.state.willUpdateStep && this.Engine.nextTimeline)) this.updatingStep();
        else if (this._stackSymbolPiece.length > 0) this.createNextAnimation(ReelState.STEP);
        else if (this.state.willStop && this.Engine.nextTimeline) this.activateStop();
    }

    protected findNextSymbol(): string {
        const reelStopReelResult: string[] = this.state.equal(ReelState.QUICK_STOP) ? this._quickStopReelSet : this._stopReelSet;
        if (this.state.isStopping && reelStopReelResult[this.Engine.Steps] != undefined) {
            if (this.Engine.Steps === reelStopReelResult.length - 1 && this.createScatterForAnticipation) {
                return "S";
            }
            return reelStopReelResult[this.Engine.Steps];
        } else {
            return this.generateNextSymbol(this._currentReelSet);
        }
    }

    public createStop(): Timeline {
        if (this._stackSymbolPiece.length && !this.isQuickStop) {
            this._spinAlreadyDelayed = true;
        }
        return super.createStop();
    }

    /**
     * override this function to  handle generate next symbols  in case of respective nudge
     * @param reelSet
     */
    protected generateNextSymbol(reelSet: string[]): string {
        if (this._stackSymbolPiece.length > 0) { // if this array has stack piece that means stack symbol is there
            return this._stackSymbolPiece.pop()!;
        } else { // this check to create an array of stack symbol
            let sym: string = this.symbolGeneratorFromReelSet(reelSet);
            sym = sym.split("*")[0];
            if (WGSymbolData.stackSymbols.indexOf(sym.split("*")[0]) > -1 && !this.isQuickStop && !this._spinAlreadyDelayed && this.state.isSpinning) {
                for (let i = 0; i < 3; i++) {
                    this._stackSymbolPiece.push((sym + "*" + i.toString()));
                }

                return this._stackSymbolPiece.pop()!;
            } else {
                return ArrayHelper.getRandomElementFromArray(["L1", "L2", "L3", "L4", "L5",]);
            }
        }
    }

    private symbolGeneratorFromReelSet(reelSet: string[]): string {
        if (this._reelSetPointer >= reelSet.length - 1) {
            this._reelSetPointer = 0;
        }
        let symbol: string = reelSet[this._reelSetPointer];
        this._reelSetPointer++;

        // removed this code as #222 is fixed
        // fix for #222 -> remove wilds from spinning reels
        // if(symbol.indexOf("W")>-1){
        //     return ArrayHelper.getRandomElementFromArray(["L1", "L2", "L3", "L4", "L5"]);
        // }
        return symbol;
    }

    /**
     * nudge code
     */
    /**
     * override this function to remove other stuff
     * @param steps
     * @param reverse
     */
    nudge(steps?: number, reverse?: boolean): TimelineMax {
        if (!steps) return new TimelineMax();

        this.setVisibleForOverflowSymbols(true);
        this.Engine.reverse = reverse != undefined ? reverse : steps < 0;
        this.Engine.Steps = Math.abs(steps);
        return this.Engine.gameNudge(this.reelID);
    }

    /**
     * override this remove calling nudge in loop
     */
    public completedNudge() {
        this.onStep();
    }

    private setWildPositions(): void {
        let symbol: IReelSpriteSymbol;
        for (let i: number = 0; i < this.AllSymbols.length; i++) {
            symbol = this.AllSymbols[i];
            if (this.AllSymbols[i].isWild) {
                switch (symbol.stateType.state) {
                    case 1:
                        symbol.y -= 15;
                        break;
                    case 3:
                        symbol.y += 15;
                        break;
                }
            }
        }
    }
}
